var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDadeMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1415 23.3381L23.2939 40.1513H0.0512695L40.1415 0V23.3381Z",
    fill: "#007040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3325 49.8486L40.1416 66.7003V89.9485L0 49.8486H23.3325Z",
    fill: "#007040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8369 66.6619L66.6846 49.8616H89.9272L49.8369 90V66.6619Z",
    fill: "#007040"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6459 40.1512L49.8496 23.2994V0.0512695L89.9784 40.1512H66.6459Z",
    fill: "#007040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDadeMark);
export default __webpack_public_path__ + "static/media/dade-mark.0aa970493c33685dbfe41027031353d1.svg";
export { ForwardRef as ReactComponent };